const Frontend = () => {
  return (
    <div className='skills__content'>
      {/* <h3 className='skills__title'>Frontend</h3> */}

      <div className='skills__box'>
        <div className='skills__group'>
          <div className='skills__data'>
            <i className='bx bxl-react'></i>
            <div>
              <h3 className='skills__name'>React.js</h3>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bxl-redux'></i>
            <div>
              <h3 className='skills__name'>Redux</h3>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bxl-typescript'></i>
            <div>
              <h3 className='skills__name'>TypeScript</h3>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bxl-javascript'></i>
            <div>
              <h3 className='skills__name'>Javascript</h3>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bxl-html5'></i>
            <div>
              <h3 className='skills__name'>HTML</h3>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bxl-css3'></i>
            <div>
              <h3 className='skills__name'>CSS</h3>
            </div>
          </div>
          <div className='skills__data'>
            <i className='bx bxl-nodejs'></i>
            <div>
              <h3 className='skills__name'>Node.js</h3>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bxl-git'></i>
            <div>
              <h3 className='skills__name'>Git</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Frontend
